import { render, staticRenderFns } from "./SidenavTemplate.vue?vue&type=template&id=d7645bd2"
import script from "./SidenavTemplate.vue?vue&type=script&lang=js"
export * from "./SidenavTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports